import { stakePoolInfo } from '@solana/spl-stake-pool'
import { web3 } from 'fbonds-core'

export const getStakePoolConversionRate = async (
  stakePoolPublicKey: web3.PublicKey,
  connection: web3.Connection,
) => {
  const info = await stakePoolInfo(connection, stakePoolPublicKey)
  let nativeSolStaked = info.details.reserveStakeLamports || 0
  for (let i = 0; i < info.details.stakeAccounts.length; i++) {
    nativeSolStaked += parseInt(info.details.stakeAccounts[i].validatorLamports)
  }
  const poolTokenSupply = parseInt(info.poolTokenSupply)
  const conversionRate = poolTokenSupply / nativeSolStaked

  return conversionRate
}

export const createGetStakePoolConversionRate = (stakePoolPublicKey: web3.PublicKey) => {
  return (connection: web3.Connection) => getStakePoolConversionRate(stakePoolPublicKey, connection)
}
